// Types
import type { Ref } from 'vue';
import type {
  TAutomatedEmailOutboxListQuery,
  TAutomatedEmailOutboxTriggerFilter,
} from '~/modules/opportunities/automated-email/outbox/types';

// Composables
import { useAutomatedEmailPatch } from '~/modules/opportunities/automated-email/composables/use-automated-email-patch';

export const useAutomatedEmailOutboxFilters = () => {
  const { patchId, saleType } = useAutomatedEmailPatch();

  const filterTriggerName: Ref<TAutomatedEmailOutboxTriggerFilter | null> = ref<
    TAutomatedEmailOutboxTriggerFilter | null
  >(null);

  const setFilterTriggerName = (value: TAutomatedEmailOutboxTriggerFilter | null): void => {
    filterTriggerName.value = value;
  };

  const getFilterTriggerName = (): TAutomatedEmailOutboxTriggerFilter | null =>
    filterTriggerName.value;

  const toQueryParams = (page: number): TAutomatedEmailOutboxListQuery | null => {
    if (patchId.value === undefined) {
      return null;
    }

    const query: TAutomatedEmailOutboxListQuery = {
      page,
      patch_id: patchId.value,
      sale_type: saleType.value,
    };

    const triggerName: TAutomatedEmailOutboxTriggerFilter | null = getFilterTriggerName();

    if (triggerName !== null) {
      query['filter[trigger_name]'] = triggerName;
    }

    return query;
  };

  return {
    patchId,
    saleType,
    filterTriggerName,
    setFilterTriggerName,
    getFilterTriggerName,
    toQueryParams,
  };
};
